var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-loading-state.ts
import { ElementsLoadingState } from "@adornis/chemistry/elements/components/x-loading-state";
import { customElement } from "lit/decorators.js";
var GELoadingState = class extends ElementsLoadingState {
  constructor() {
    super();
    this.styles = () => ({ ":host": { display: "block" } });
    this["no-wrapper"] = true;
  }
};
GELoadingState = __decorateClass([
  customElement("ge-loading-state")
], GELoadingState);
export {
  GELoadingState
};
